/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * A color and an alpha.
 */
export interface DColorAndAlpha {
	/**
	 * A color.
	 */
	color: number;

	/**
	 * An alpha.
	 */
	alpha: number;
}
